module.exports = __webpack_public_path__ + "img/106-Sheffield Oak Klonial.jpg";